import React from "react";

import {formatCurrency} from "./CalculatorLogic";
import {colors} from "nxtconstants";
import {
  SWP_ACCENT,
  SWP_ACCENT_TEXT,
  DataTable,
  LegendContainer,
  LegendItem,
  LegendLabel,
  LegendSwatch,
  MobileSummaryCard,
  MobileSummaryRow,
  MobileTabButton,
  MobileTabContainer,
  SummaryGrid,
  SummaryItem,
  SummaryLabel,
  SummaryValue,
  TableWrapper,
  TooltipTotalRow,
  ViewToggleButton,
  ViewToggleContainer
} from "./CalculatorStyle";
import {
  TooltipContainer,
  TooltipRow,
  TooltipTitle,
  TooltipValue
} from "components/ClientHome/CalculatorStyle";

export const MobileTabToggle = ({activeTab, onChange}) => (
  <MobileTabContainer>
    <MobileTabButton
      active={activeTab === "input"}
      type="button"
      onClick={() => onChange("input")}
    >
      Input
    </MobileTabButton>
    <MobileTabButton
      active={activeTab === "result"}
      type="button"
      onClick={() => onChange("result")}
    >
      Result
    </MobileTabButton>
  </MobileTabContainer>
);

export const SummaryCards = ({
  corpusBeforeSwp,
  corpusUsed,
  finalCorpus,
  withdrawalStartAge
}) => (
  <>
    <SummaryGrid>
      <SummaryItem>
        <SummaryLabel>Corpus at Age {withdrawalStartAge}</SummaryLabel>
        <SummaryValue>{formatCurrency(corpusBeforeSwp)}</SummaryValue>
      </SummaryItem>
      <SummaryItem>
        <SummaryLabel>Total Withdrawal</SummaryLabel>
        <SummaryValue>{formatCurrency(corpusUsed)}</SummaryValue>
      </SummaryItem>
      <SummaryItem>
        <SummaryLabel>Remaining Corpus</SummaryLabel>
        <SummaryValue>{formatCurrency(finalCorpus)}</SummaryValue>
      </SummaryItem>
    </SummaryGrid>

    <MobileSummaryCard>
      <MobileSummaryRow $highlight>
        <span>Corpus at Age {withdrawalStartAge}</span>
        <span>{formatCurrency(corpusBeforeSwp)}</span>
      </MobileSummaryRow>
      <MobileSummaryRow>
        <span>Total Withdrawal</span>
        <span>{formatCurrency(corpusUsed)}</span>
      </MobileSummaryRow>
      <MobileSummaryRow>
        <span>Remaining Corpus</span>
        <span>{formatCurrency(finalCorpus)}</span>
      </MobileSummaryRow>
    </MobileSummaryCard>
  </>
);

export const ViewToggle = ({activeView, onChange}) => (
  <ViewToggleContainer>
    <ViewToggleButton
      active={activeView === "graph"}
      type="button"
      onClick={() => onChange("graph")}
    >
      Graph
    </ViewToggleButton>
    <ViewToggleButton
      active={activeView === "table"}
      type="button"
      onClick={() => onChange("table")}
    >
      Table
    </ViewToggleButton>
  </ViewToggleContainer>
);

export const YearlyTable = ({yearlyData}) => (
  <TableWrapper>
    <DataTable>
      <thead>
        <tr>
          <th>Age</th>
          <th>Monthly Withdrawal</th>
          <th>Yearly Withdrawal</th>
          <th>Year End Corpus</th>
        </tr>
      </thead>
      <tbody>
        {yearlyData.map((row) => (
          <tr key={row.year}>
            <td>{row.year}</td>
            <td>{formatCurrency(row.monthly)}</td>
            <td>{formatCurrency(row.yearly)}</td>
            <td>{formatCurrency(row.yearEndCorpus)}</td>
          </tr>
        ))}
      </tbody>
    </DataTable>
  </TableWrapper>
);

export const ChartHoverInfo = ({active, payload, label}) => {
  if (!active || !payload || !payload.length) {
    return null;
  }

  const investment = payload[0].value;
  const gain = payload[1]?.value ?? 0;

  return (
    <TooltipContainer>
      <TooltipTitle>{label}</TooltipTitle>
      <TooltipRow color={colors.primary}>
        Investment <TooltipValue>{formatCurrency(investment)}</TooltipValue>
      </TooltipRow>
      <TooltipRow color={SWP_ACCENT_TEXT}>
        Gain <TooltipValue>{formatCurrency(gain)}</TooltipValue>
      </TooltipRow>
      <TooltipTotalRow>
        Year End Corpus <TooltipValue>{formatCurrency(investment + gain)}</TooltipValue>
      </TooltipTotalRow>
    </TooltipContainer>
  );
};

export const ChartLabel = () => (
  <LegendContainer>
    <LegendItem>
      <LegendSwatch color={colors.primary} />
      <LegendLabel>Investment</LegendLabel>
    </LegendItem>
    <LegendItem>
      <LegendSwatch color={SWP_ACCENT} />
      <LegendLabel>Gain</LegendLabel>
    </LegendItem>
  </LegendContainer>
);
